let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("blgK2")).then(() => parcelRequire('g4x51'));